import * as React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';

import {
    Typography,
} from '@material-ui/core';

import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { contactEmail } from '../../../common/constants';
import logo from '../../../common/image/logo negativ stor.svg';
import fbIcon from '../../../common/image/facebook48.png';
import twitterIcon from '../../../common/image/twitter48.png';
import linkedinIcon from '../../../common/image/linkedin48.png';
import { Image } from '../../../youwell-common/components';
import urls from '../../../app/urls';

const styles = theme => ({
    root: {
        height: theme.sizes.footerHeight,
        padding: theme.spacing(0, 4),
        display: 'flex',
        flexShrink: 0,
        alignItems: 'center',
        color: theme.palette.common.white,
        background: theme.colors.blue4,

        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
            padding: 0,
            height: 'auto',
        },

        '@media print': {
            display: 'none',
        },
    },
    item: {
        flex: '1 1 auto',
        height: '100%',
        padding: theme.spacing(4, 2),
        display: 'flex',
        flexDirection: 'column',

        [theme.breakpoints.down('sm')]: {
            height: 'auto',
        },
    },
    firstItem: {
        flex: '2 1 auto',
    },
    logo: {
        width: 100,
    },
    link: {
        display: 'block',
        marginBottom: theme.spacing(2),
    },
    underline: {
        borderBottom: '1px solid',
    },
    titleText: {
        marginTop: theme.spacing(2),
        width: 150,
    },
    share: {
        marginTop: theme.spacing(2),
        justifySelf: 'flex-end',
        display: 'flex',
    },
    shareLink: {
        marginRight: theme.spacing(1),
    },
});

class Footer extends React.Component {
    render() {
        const {
            classes, appConfig,
        } = this.props;

        return (
            <div className={classes.root}>
                <div className={classnames(classes.item, classes.firstItem)}>
                    <Image src={logo} alt="Logo" className={classes.logo} />
                    <Typography variant="subtitle1" color="inherit" className={classes.titleText}>
                        <Translate id="frontpage.aSimplerDayForKids" />
                    </Typography>
                </div>
                <div className={classes.item}>
                    <Typography color="inherit">
                        <Translate id="frontpage.contactUs" />
                    </Typography>
                    <a href={`mailto:${contactEmail}`} className={classes.link}>
                        <Typography color="inherit" gutterBottom>
                            <span className={classes.underline}>
                                {contactEmail}
                            </span>
                        </Typography>
                    </a>
                    <Link to={`${urls.page}/${appConfig.privacyPolicyTaskId}`} className={classes.link}>
                        <Typography color="inherit" gutterBottom>
                            <span className={classes.underline}>
                                <Translate id="frontpage.privacyPolicy" />
                            </span>
                        </Typography>
                    </Link>
                </div>
                <div className={classes.item}>
                    <div className={classes.share}>
                        <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fvimo.no">
                            <Image src={fbIcon} alt="Share on Facebook" className={classes.shareLink} />
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/intent/tweet?text=https%3A%2F%2Fvimo.no">
                            <Image src={twitterIcon} alt="Share on Twitter" className={classes.shareLink} />
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/sharing/share-offsite/?url=https%3A%2F%2Fvimo.no">
                            <Image src={linkedinIcon} alt="Share on LinkedIn" className={classes.shareLink} />
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}

Footer.propTypes = {
    classes: PropTypes.object.isRequired,
    appConfig: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    appConfig: state.pageSettings.appConfig,
});

export default connect(mapStateToProps)(withStyles(styles)(Footer));
